import { DefaultCard, InverseOutlineCard, InverseCard, OutlineCard, InteractiveCard, InteractiveInverseCard } from './styles.js';

function getCardVariant(props) {
    switch (props.variant) {
        case 'outline':
            return OutlineCard;
        case 'inverse':
            return InverseCard;
        case 'inverse-outline':
            return InverseOutlineCard;
        case 'default':
        default:
            return DefaultCard;
    }
}
function getCardInteractiveStyles(props) {
    if (props.interactive) {
        switch (props.variant) {
            case 'inverse':
            case 'inverse-outline':
                return InteractiveInverseCard;
            case 'default':
            case 'outline':
            default:
                return InteractiveCard;
        }
    }
}

export { getCardInteractiveStyles, getCardVariant };
